import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { VideoDialogState } from "../../reducers/components/VideoDialogReducer";
import { RootState } from "../../reducers/index";
import useStyles from "./VideoDialog.css";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { style } from "@material-ui/system";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import Player from "video.js/dist/types/player";

export default function VideoDialog() {
  const classes = useStyles();
  const videoDialogData = useSelector<RootState, VideoDialogState>(
    (state) => state.videoDialogDetails
  );
  const videoRef = React.useRef<any>(null);
  const playerRef = React.useRef<Player|null>(null);
  //let videoElm : HTMLDivElement;
  //const {src, onReady} = props;

  const videoJsOption = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [{
      src: 'video.mp4',
      type: 'video/mp4'
    }]
  };

  React.useEffect(() => {
    setTimeout(() => {
      // Make sure Video.js player is only initialized once
      if (videoDialogData.open ) {
        // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
        const videoElement = document.createElement("video-js");
        videoElement.classList.add('vjs-big-play-centered');
        if(videoRef.current){
        
          videoRef.current.appendChild(videoElement);
          videoJsOption.sources[0].src = process.env.REACT_APP_BASE_URL + 'LearningVideo/GetVideos?subscription-key='+ process.env.REACT_APP_APIM_SUBSCRIPTION_KEY +'&videoName=' + videoDialogData.src;
          const player = playerRef.current = videojs(videoElement, videoJsOption, () => {
            videojs.log('player is ready');
            videoDialogData.onReady && videoDialogData.onReady(player);
          });
        }

      // You could update an existing player in the `else` block here
      // on prop change, for example:
      } //else {
        //const videoElement = document.createElement("video-js");
        //const player = playerRef.current;

        //player?.autoplay(videoJsOptions.autoplay);
        //player?.src(videoJsOptions.sources);
      //}
    },500);
  }, [videoDialogData.open]);

//   React.useCallback(() => {
//     // Make sure Video.js player is only initialized once
//     if (!playerRef.current && videoDialogData.open) {
//      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
//      const videoElement = document.createElement("video-js");
//      videoElement.classList.add('vjs-big-play-centered');
//      if(videoRef.current){
     
//        videoRef.current.appendChild(videoElement);

//        const player = playerRef.current = videojs(videoElement, videoJsOption, () => {
//          videojs.log('player is ready');
//          videoDialogData.onReady && videoDialogData.onReady(player);
//        });
//      }

//    // You could update an existing player in the `else` block here
//    // on prop change, for example:
//    } else {
//      const player = playerRef.current;

//      player?.autoplay(videoJsOptions.autoplay);
//      player?.src(videoJsOptions.sources);
//    }
//  }, [videoJsOption, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  const dispatch = useDispatch();

  const videoJsOptions = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [{
      src: '/path/to/video.mp4',
      type: 'video/mp4'
    }]
  };

  const handleClose = () => {
    dispatch({
      type: "CLOSE_VIDEO_DIALOG",
      payload: [],
    });
  };

  const handleOpen = () => {
    dispatch({
      type: "CLOSE_VIDEO_DIALOG",
      payload: [],
    });
  };

  return (
    <div>
      <Dialog
        className={classes.popUpOuter}
        open={videoDialogData.open}
        onClose={handleClose}
        aria-labelledby="video-dialog-title"
        aria-describedby="video-dialog-description"
      >
        <DialogTitle className={classes.popUpHeader} id="video-dialog-title">
          {videoDialogData.title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper}>
          <div data-vjs-player style={{width:"900px", height:"500px"}}>
            <div ref={videoRef}/>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ margin: "20px ​10px 15px 0" }}>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={videoDialogData.btnOneOnclick} color="primary">
                {/* <CheckCircleIcon></CheckCircleIcon> */}
                {videoDialogData.btnOnetext}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
